import { useI18nContext } from '@i18n/i18n-react';
import { SheetSortDirection } from '@common/api';
import { ContextMenu, ContextMenuRenderProps } from '@components/context-menu/ContextMenu';
import { ArrowUp, ArrowDown } from '@components/icons/FarseerIcons';
import { SheetFreezeMenu } from '../context-menu/SheetFreezeMenu';
import { useSheetEditorContext } from '../editor/SheetEditorProvider';
import { useSheetEditorSort } from '../editor/useSheetEditorSort';

export const SheetTimelineColumnsEditMenu = ({
    columnKey,
    columnIndex,
    ...menuProps
}: {
    columnKey: string;
    columnIndex: number;
} & ContextMenuRenderProps) => {
    const { LL } = useI18nContext();

    const {
        state: { referencing },
    } = useSheetEditorContext();

    const { addRule } = useSheetEditorSort();

    const handleSort = (direction: SheetSortDirection) => {
        addRule(columnKey, direction);
    };

    return (
        <ContextMenu {...menuProps} placement="bottom-start">
            <ContextMenu.Item
                item={{
                    icon: ArrowUp,
                    label: LL.ASCENDING(),
                    disabled: referencing.sort,
                    action: () => {
                        handleSort(SheetSortDirection.Asc);
                    },
                }}
            />
            <ContextMenu.Item
                item={{
                    icon: ArrowDown,
                    label: LL.DESCENDING(),
                    disabled: referencing.sort,
                    action: () => {
                        handleSort(SheetSortDirection.Desc);
                    },
                }}
            />
            <ContextMenu.Divider />
            <SheetFreezeMenu columnIndex={columnIndex} />
        </ContextMenu>
    );
};
